import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { SignIn } from "@clerk/react";
import { useAuth } from "@/contexts/AuthContext";
import ClerkAuthShell from "@/components/ClerkAuthShell";

export default function LoginPage() {
  const { user, loading, clerkSignedIn, sessionError, checkAuth, logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) navigate("/dashboard", { replace: true });
  }, [user, navigate]);

  if (loading && clerkSignedIn) {
    return (
      <ClerkAuthShell testId="login-page">
        <div className="text-sm" style={{ color: "var(--hoip-text-secondary)" }}>Signing you in…</div>
      </ClerkAuthShell>
    );
  }

  return (
    <ClerkAuthShell testId="login-page">
      {sessionError ? (
        <div className="text-sm max-w-sm text-center space-y-3" style={{ color: "var(--hoip-text-secondary)" }}>
          <div>{sessionError}</div>
          <div className="flex items-center justify-center gap-2">
            <button type="button" onClick={() => checkAuth()} className="px-3 py-1.5 text-xs font-bold rounded-sm"
              style={{ background: "var(--hoip-text-primary)", color: "var(--hoip-bg)" }}>Retry</button>
            <button type="button" onClick={async () => { await logout(); window.location.reload(); }}
              className="px-3 py-1.5 text-xs rounded-sm border"
              style={{ borderColor: "var(--hoip-border)" }}>Sign out</button>
          </div>
        </div>
      ) : (
        <SignIn
          routing="path"
          path="/login"
          signUpUrl="/sign-up"
          forceRedirectUrl="/dashboard"
          fallbackRedirectUrl="/dashboard"
        />
      )}
    </ClerkAuthShell>
  );
}
